import React from 'react';

import { clearPreviewCookie } from 'Redux/ducks/blog';

export default function BlogPreviewBanner() {
  return (
    <div className="blog-warning-bar">
      Warning - This is a preview blog post -&nbsp;
      <button onClick={() => clearPreviewCookie()}>Click here to clear cookie</button>
    </div>
  );
}
